<template>
    <div id="app" @drop.stop.prevent="drop" @dragover.prevent="dragover" @dragleave.prevent="dragleave" @dragenter.prevent>
        <div v-if="dragging" class="dragging"></div>
        <loading :app="app">
            <router-view :app="app" />
        </loading>
    </div>
</template>

<style lang="scss">
@import "./index.scss";
</style>

<script>
import Vue           from 'vue';
import parse         from '../org-parser';
import superstore    from '@/data';
// import helpers       from '@/data/models/lib/helpers';
import Loading       from '@/components/loading/component.vue';
import Connections   from '@/components/connections';

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', function() {
        navigator.serviceWorker.register('./sw.js');
    });
}

var KEYWORDS = ['PROJECT', 'GOAL', 'TODO', 'WAIT', 'QUEUE', 'IDEA', 'DONE'],
    HTMLIFY = /\[\[(.+)\]\[(.+)\]\]/g,
    DATEIFY = /(<|\[)(\d{4})-(\d{2})-(\d{2})([^>]+)?(>|\])/g,
    DRAG_TIMEOUT;

export default {
    components: {
        Loading,
    },
    data() {
        var _ = this;

        window.app = _;

        return {
            app: _,
            config: _.getConfig(),
            isLoading: false,
            isReloading: false,
            dragging: false,
            rootNode: undefined,
            // helpers: helpers,
            models: superstore.models,
            data: superstore.data,
            file: '',
            q: ''
        };
    },
    watch: {
        file(val) {
            var _ = this;

            _.rootNode = undefined;
            _.setRootNode(val);

            if (_.$router.currentRoute.path !== '/read') {
                _.$router.push('/read');
            }
        }
    },
    methods: {
        refresh() {
            var _ = this;

            _.isReloading = true;

            _.connection.get('/index.org', function(err, data) {
                if (data) {
                    _.setRootNode(data.Body.toString());
                }

                _.isReloading = false;
            });
        },

        setRootNode(data) {
            var _ = this;

            _.rootNode = new Vue({
                data: {
                    type: 'root',
                    children: parse(data),
                    isExpanded: true
                }
            });

            return _.rootNode;
        },

        getConfig() {
            try {
                return JSON.parse(window.localStorage.getItem('config') || '{}');
            } catch (e) {e;
                return {};
            }
        },

        setConfig(config, redirect) {
            if (!config.type) {
                return;
            }

            var _ = this;

            _.isLoading = true;
            _.connection = new Connections[config.type](config);

            _.connection.get('/index.org', function(err, data) {
                if (err) {
                    alert(err);

                    _.isLoading = false;
                    _.connection = undefined;

                    if (redirect) {
                        _.$router.push('/s3');
                    }

                    return;
                }

                _.config = config;
                window.localStorage.setItem('config', JSON.stringify(config));

                _.file = data.Body.toString();
                _.isLoading = false;
            });
        },

        closeDescendents(node) {
            var _ = this;

            for (var i = node.children.length - 1; i >= 0; i--) {
                node.children[i].isExpanded = false;
                _.closeDescendents(node.children[i]);
            }
        },

        expandNode(node) {
            node.isExpanded = true;
        },

        highlightNode(node) {
            Vue.set(node, 'klass', 'node highlight');

            setTimeout(function() {
                Vue.set(node, 'klass', '');
            }, 0);
        },

        expandAncestry(node) {
            var _ = this;

            if (node.parent) {
                _.expandNode(node.parent);
                _.expandAncestry(node.parent);
            }
        },

        expandChildren(node, recursive) {
            var _ = this;

            node.isExpanded = true;

            for (var i = node.children.length - 1; i >= 0; i--) {
                node.children[i].isExpanded = true;

                if (recursive) {
                    _.expandChildren(node.children[i]);
                }
            }
        },

        compactNode(node) {
            node.isExpanded = false;

            for (var i = node.children.length - 1; i >= 0; i--) {
                node.children[i].isExpanded = false;
            }
        },

        toggleNode(node, toggler) {
            var _ = this;

            if (typeof toggler === 'object') {
                toggler.toggle(node);
            } else {
                if (node.isExpanded) {
                    _.compactNode(node);
                } else {
                    _.expandNode(node);
                }
            }
        },

        prefix(type, level) {
            if (!level) {
                return '';
            }

            var str = '',
                bullet = '-';

            if (type === 'headline') {
                bullet = '*';
            }

            for (var i = level; i > 1; i--) {
                str += '<span class="unimportant">' + bullet + '</span>';
            }

            return str + '<span>' + bullet + '</span> ';
        },

        todoify(str) {
            if (!str) {
                return '';
            }

            for (var i = KEYWORDS.length - 1; i >= 0; i--) {
                str = str.replace(KEYWORDS[i], function(a) {
                    return `<mark class="${a.toLowerCase()}">${a}</mark>`;
                });
            }

            return str;
        },

        htmlify(str) {
            if (!str) {
                return '';
            }

            str = str.replace(DATEIFY, function(date) {
                return `<time>${date}</time>`;
            });

            str = str.replace(HTMLIFY, '<a href="$1" target="_blank">$2</a>');

            return str;
        },

        upload(file) {
            var _ = this,
                files = file && file.target ? file.target.files : [file];

            if (!files || !files[0]) {
                return alert('Invalid File.');
            }

            var reader = new FileReader();

            reader.readAsText(files[0], 'UTF-8');

            reader.onload = function(e) {
                _.file = e.target.result;
            };

            reader.onerror = function() {
                alert('There was an error reading your file.');
            };
        },

        drop(event) {
            var _ = this;

            _.dragging = false;
            _.upload(event.dataTransfer.files[0]);
        },

        dragover() {
            var _ = this;

            clearTimeout(DRAG_TIMEOUT);

            _.dragging = true;
        },

        dragleave() {
            var _ = this;

            clearTimeout(DRAG_TIMEOUT);

            DRAG_TIMEOUT = setTimeout(function() {
                _.dragging = false;
            }, 100);
        }
    }
};
</script>
